module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "selectParent"
  }, [_c('div', {
    staticClass: "selectitem1"
  }, [_c('router-link', {
    attrs: {
      "to": "/class",
      "active-class": "u-link--Active1"
    }
  }, [_c('div', {
    staticClass: "select1"
  }, [_vm._v("课时核对")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "selectitem2"
  }, [_c('router-link', {
    attrs: {
      "to": "/record",
      "active-class": "u-link--Active2"
    }
  }, [_c('div', {
    staticClass: "select1"
  }, [_vm._v("我的档案")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80b8ea2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ParentMain.vue
// module id = 790
// module chunks = 1